/**
 * Type guard to safely check if a value is an Error instance
 */
export function isError(error: unknown): error is Error {
  return error instanceof Error;
}

/**
 * Safely extract error message from unknown error type
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return 'An unknown error occurred';
}

/**
 * Safely extract error name from unknown error type
 */
export function getErrorName(error: unknown): string {
  if (error instanceof Error) {
    return error.name;
  }
  return 'Error';
}

/**
 * Check if error has a specific property
 */
export function hasProperty<K extends string>(
  error: unknown,
  property: K
): error is Record<K, unknown> {
  return typeof error === 'object' && error !== null && property in error;
}
